import { Link } from 'react-router-dom';
import styled from 'styled-components';

import PrimaryButtonLoading from '../../shared/buttons/loadingButtons/PrimaryButtonLoading';

export const EmailSentBox = styled.div`
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BackLink = styled(Link)`
  display: block;
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: 0.3px;
  text-align: center;
  color: ${({ theme }) => theme.white.a10};
  margin-top: 50px;

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.white.a10};
  }
`;

export const FormLink = styled(Link)`
  color: ${({ theme }) => theme.white.a10};
  font-size: 0.8rem;
  margin-top: 10px;

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.white.a10};
  }
`;

export const SubmitBtn = styled(PrimaryButtonLoading)`
  width: 100%;
  height: 50px;
  margin-top: 40px;
  min-width: auto;
`;
